import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import './MainLayout.css';
import { ToastContainer } from "react-toastify";
import MainBottomTabs from "../components/BottomTabs/MainBottomTabs";
import Topbar from "../components/Header/Topbar";

function MainLayout({ children, isTopBar, screenTitle, headerLeft }) {
  const isDesktop = window.innerWidth >= 1024;

  return (
    <>
      {isTopBar && !isDesktop ?
        <Topbar title={screenTitle} headerLeft={headerLeft} />
      :
        <Header />
      }

      <main style={{marginTop: isTopBar && !isDesktop ? '0px' : '71px'}}>
        {children}
      </main>

      {!isTopBar && !isDesktop &&
        <MainBottomTabs />
      }

      <Footer />

      <ToastContainer 
        pauseOnFocusLoss={false}
        pauseOnHover={false}
        autoClose={2000}
      />
    </>
  );
}

export default MainLayout;